/* React */
import React from "react";

/* Constants */
import { ChartType } from "src/shared/constants/charts/Chart";
import { TableType } from "src/shared/constants/charts/Table";

/* Utils */
import { mapKeyToTableLabelMapper } from "src/utils/layout/unstacked-layout/helper";

/* Components */
import Table from "src/components/shared/table/Table";

/* Interfaces */
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";

import { TreatmentPatternsProps } from "src/shared/interfaces/TreatmentPatterns";
import { ComponentProps } from "src/shared/interfaces/common/Layout";

export const createTable = (
  outerIndex: number,
  data: BaseChartProps<
    TreatmentPatternsProps[],
    ChartType[][]
  >
) => {
  const item = data.data[outerIndex];

  const components: ComponentProps[] = [];

  Object.entries(item).forEach(([key, value]) => {
    if (
      value &&
      typeof value === "object" &&
      "type" in value &&
      value.type === "table" &&
      "data" in value
    ) {
      components.push({
        component: (
          <Table
            key={`${key}-table-${outerIndex}`}
            index={outerIndex}
            stacked={false}
            label={key}
            data={[{ ...value, name: item.name }]}
            labelMapping={mapKeyToTableLabelMapper(
              key as TableType
            )}
            downloadFilename={`${item.name}-${key}`}
            splitCountPercent={true}
          />
        ),
        fullWidth: true,
      });
    }
  });

  return components;
};
